import axios from 'axios'
import { setInterceptors } from './adminAxiosInterceptors'
import qs from 'qs'

function createAxiosService () {
  const axiosService = axios.create({
    baseURL: process.env.VUE_APP_SERVER + '/api/v1.0/',
    timeout: 10000,
    paramsSerializer: params => {
      return qs.stringify(params)
    }
  })
  return setInterceptors(axiosService)
}

const axiosService = createAxiosService()

export default axiosService
